export default __webpack_public_path__ + "static/five-legos-94699efabf99f5f9208a161510500a42.png";